import * as R from 'ramda'
import React from 'react'

import BasePlacesAutocompleteFormsy from './BasePlacesAutocompleteFormsy'

const PlacesAddressAutocompleteFormsy = (props) => {
  return (
    <BasePlacesAutocompleteFormsy
      {...props}
      parseValue={R.propOr('', 'formatted_address')}
    />
  )
}

export default PlacesAddressAutocompleteFormsy
